import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 6 48",
  "content": "<symbol viewBox=\"0 0 6 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-down\">\n<path d=\"M3 48L5.88675 43L0.113247 43L3 48ZM2.5 -2.18557e-08L2.5 43.5L3.5 43.5L3.5 2.18557e-08L2.5 -2.18557e-08Z\" fill=\"#64748B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol